(() => {
  const stickySection = document.querySelector(
    '.shopify-section.shopify-section--sticky-cta-button:has(.sticky-cta-button)'
  );
  if (!stickySection) return;

  function isStickyElement(el) {
    let node = el;
    while (node && node !== document.body) {
      const style = window.getComputedStyle(node);
      const pos = style.position;
      if (pos === 'sticky' || pos === 'fixed') {
        return true;
      }
      node = node.parentElement;
    }
    return false;
  }

  const allAnchors = Array.from(
    document.querySelectorAll('a[href="#product-information-section"]')
  );

  const anchors = allAnchors.filter((a) => !isStickyElement(a));

  if (!anchors.length) {
    stickySection.classList.remove('is-hidden');
    return;
  }

  let lastHiddenState = null;
  let ticking = false;

  function isAnchorVisible(anchor) {
    if (!anchor) return false;

    const rect = anchor.getBoundingClientRect();
    const style = window.getComputedStyle(anchor);

    if (
      style.display === 'none' ||
      style.visibility === 'hidden' ||
      parseFloat(style.opacity || '1') <= 0.01
    ) {
      return false;
    }

    const vh = window.innerHeight || document.documentElement.clientHeight;
    const vw = window.innerWidth || document.documentElement.clientWidth;

    const verticallyVisible = rect.bottom > 0 && rect.top < vh;
    const horizontallyVisible = rect.right > 0 && rect.left < vw;
    if (!verticallyVisible || !horizontallyVisible) return false;

    const anchorHeight = rect.height || 1;
    const visibleTop = Math.max(rect.top, 0);
    const visibleBottom = Math.min(rect.bottom, vh);
    const visibleHeight = Math.max(0, visibleBottom - visibleTop);
    const visibleRatio = visibleHeight / anchorHeight;

    return visibleRatio >= 0.2;
  }

  function updateVisibility() {
    ticking = false;

    const anyVisible = anchors.some(isAnchorVisible);

    if (anyVisible === lastHiddenState) return;
    lastHiddenState = anyVisible;

    stickySection.classList.toggle('is-hidden', anyVisible);
  }

  function onScrollOrResize() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(updateVisibility);
  }

  updateVisibility();

  window.addEventListener('scroll', onScrollOrResize, { passive: true });
  window.addEventListener('resize', onScrollOrResize);
})();